import { mapState } from "vuex";

const trimParenthesis = (str) => (str ? str.replace(/[()]/g, "") : "");

const simplify = (str) => trimParenthesis(str).toLowerCase();

export default {
  computed: {
    ...mapState("catalogs", {
      rawProcesses: (state) => state["macro/Carreteras/process"],
    }),
    /*
     * affected process should be implemented in local component
     */
    affectedProcess() {
      return this.process.abbreviation;
    },
    processes() {
      return this.rawProcesses.map(({ abbreviation, ...process }) => ({
        ...process,
        abbreviation,
        code: simplify(abbreviation),
      }));
    },
    processCode() {
      return simplify(this.affectedProcess);
    },
    processNumber() {
      const { processCode } = this;
      const process = this.processes.find(({ code }) => code === processCode);
      return process ? process.number : -1;
    },
  },
  methods: {
    /**
     * Checks if affected process is any of the given parameters
     * this.processIs('RS', 'DS')
     * It should ignore
     */
    processIs(...processAbbrevs) {
      return processAbbrevs.map(simplify).includes(simplify(this.processCode));
    },
    /**
     * Checks that process is greater than
     */
    processIsGreaterThan(processAbbre) {
      const { processes, processNumber } = this;
      const simpAbbre = simplify(processAbbre);
      const proc = processes.find(({ code }) => code === simpAbbre);
      return proc ? processNumber > proc.number : false;
    },
    processIsSmallerThan(processAbbre) {
      const { processes, processNumber } = this;
      const simpAbbre = simplify(processAbbre);
      const proc = processes.find(({ code }) => code === simpAbbre);
      return proc ? processNumber < proc.number : false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/RoadSinisters/File/mixins/processCalculations.js